import React from 'react'
import styles from './ToggleSwitch.module.scss'
import classNames from 'classnames'
import LoaderMini from '../loaderMini/LoaderMini'

const ToggleSwitch = (props) => {
  const { disabled, error, spinner, onClick, activeState, id, dataType } = props

  const toggleRef = React.createRef()
  const value = activeState ? 'checked' : 'unchecked'
  const classes = classNames(
    styles.switchBg,
    { [styles.off]: !activeState },
    { [styles.disabled]: disabled },
    { [styles.error]: error },
    { [styles.spinner]: spinner }
  )

  const toggle = (event) => {
    onClick(event)
  }

  const renderContent = () => {
    if (spinner) {
      return <LoaderMini />
    }

    return <span className={styles.switch}/>
  }

  return (
    <label className={styles.switchContainer}>
      <input
        type="checkbox"
        value={value}
        onChange={toggle}
        checked={activeState}
        disabled={disabled}
        data-id={id}
        data-type={dataType}
        ref={toggleRef}
      />
      <span className={classes}>{renderContent()}</span>
    </label>
  )
}

export default ToggleSwitch
